import { useTranslation } from 'react-i18next';
import AddOnsCard from '../../components/settings/add-ons-card.tsx';
import { SettingsLeafPage } from '../../components/settings/settings-leaf-page.tsx';

/** Settings › Pricing & quotes › Add-ons: only this card, so only its reads run. */
export default function PricingAddOnsPage() {
  const { t } = useTranslation();
  return (
    <SettingsLeafPage
      title={t('settings.pricingPages.tiles.addOns.title')}
      back={{ to: '/settings/pricing', label: t('settings.pricingPages.backToPricing') }}
    >
      <AddOnsCard />
    </SettingsLeafPage>
  );
}
